export default "__VITE_ASSET__CG353LQv__"